import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorCms } from '../../interfaces/error-cms.interface';

@Component({
  selector: 'lmw-error-bad-request',
  templateUrl: './bad-request.component.html'
})
export class BadRequestComponent implements OnInit {

  public errorCms: ErrorCms;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.errorCms = this.route.snapshot.data.cmsData;
  }

}
